/**
 * Checks if the current route is a standalone auth portal page.
 * These pages handle their own authentication and should skip AuthProvider initialization.
 * NOTE: PWA app routes (/maintenance-team, /tenant, /vendor-tech) should NOT skip auth.
 */
export const isStandaloneAuthPortalRoute = (path: string): boolean => {
  const authPortals = [
    '/maintenance-auth',
    '/tenant-auth',
    '/vendor-tech-auth',
    '/vendor-auth',
    '/vendorshield-pro-auth',
    '/admin/dev-portal',
    '/admin/baseline-collection',
    '/survey/maintenance',
    '/survey/print',
    '/survey/flyer'
  ];
  return authPortals.some(portal => path.startsWith(portal));
};

/**
 * @deprecated Use isStandaloneAuthPortalRoute instead
 */
export const isVendorRoute = isStandaloneAuthPortalRoute;

export const parseStoredUser = (storedUser: string) => {
  try {
    return JSON.parse(storedUser);
  } catch (error) {
    console.error('Failed to parse stored user:', error);
    return null;
  }
};

/**
 * SECURITY: Store only user ID in localStorage to minimize XSS attack surface.
 * Full user data should be fetched from Supabase on demand.
 * @deprecated Use Supabase session instead of localStorage for user data
 */
export const saveUserToStorage = (user: { id: string }): void => {
  try {
    // SECURITY: Only store the user ID, not full PII
    // This minimizes data exposure if XSS occurs
    localStorage.setItem('user_id', user.id);
  } catch (error) {
    console.warn('Failed to save user ID to localStorage:', error);
  }
};

/**
 * Get stored user ID (not full user object)
 * Full user data should be fetched from Supabase
 */
export const getStoredUserId = (): string | null => {
  try {
    return localStorage.getItem('user_id');
  } catch (error) {
    console.warn('Failed to get user ID from localStorage:', error);
    return null;
  }
};

export const clearUserFromStorage = (): void => {
  try {
    // Clear both legacy 'user' key and new 'user_id' key
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
  } catch (error) {
    console.warn('Failed to clear user from localStorage:', error);
  }
};

export const testLocalStorage = (): boolean => {
  try {
    localStorage.setItem('test', 'test');
    localStorage.removeItem('test');
    return true;
  } catch {
    return false;
  }
};
